import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

const TimedPlusTooltip = () => (
    <Tooltip
        placement="bottom-end"
        trigger={
            <Info
                color="primary"
                size="sm"
                style="fill"
            />
        }
    >
        <FormattedMessage
            id="itemPage.biddingInfo.timedPlus.timedPlusDescription"
            values={{
                helpLink: (
                    <Link
                        key="timed-plus-tooltip-help-link"
                        target="_blank"
                        to="https://support.liveauctioneers.com/hc/en-gb/articles/24574071591313-How-do-Timed-auctions-work"
                    >
                        <FormattedMessage id="itemPage.biddingInfo.timedPlus.helpLinkText" />
                    </Link>
                ),
            }}
        />
    </Tooltip>
);

export default TimedPlusTooltip;
